import { postApiCall } from "../../utils/request";
import axios from "axios";

export const startTest = (assignment_id) => async (dispatch) => {
  try {
    const response = await postApiCall(`language-tests/assignments/${assignment_id}/start`);
    if (response.status === 200 && response.data?.status === "success") {
      dispatch({ type: "START_TEST_SUCCESSFULLY", payload: response.data.data });

      return { success: true, payload: response.data.data };
    }

    dispatch({ type: "START_TEST_FAILED", message: "Failed to start test" });
    return { success: false };

  } catch (error) {
    if (
      error?.response?.status === 400 &&
      error?.response?.data?.detail === "Assignment already completed"
    ) {
      return { alreadyCompleted: true };
    }
    dispatch({ type: "START_TEST_FAILED", message: "Something went wrong" });
    return { success: false };
  }
};

export const startAssessment = (assignment_id) => async (dispatch) => {
  try {
    const response = await postApiCall(`assignment-questions/${assignment_id}/start`)
    if (response.status === 200 && response.data?.status === "success") {
      return { success: true, payload: response.data.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    if (
      error?.response?.status === 400 &&
      error?.response?.data?.detail === "Assignment already completed"
    ) {
      return { alreadyCompleted: true };
    }
    return { success: false };
  }
};

export const uploadAudio = (formData) => async (dispatch) => {
  try {
    const response = await postApiCall("audio/upload-audio", formData);

    if (response.status === 200 && response.data.success) {
      dispatch({ type: "UPLOAD_AUDIO_SUCCESS", payload: response.data.data});
      return { success: true, payload: response.data.data };
    } else {
      dispatch({ type: "UPLOAD_AUDIO_FAILED", message: "Upload failed" });
      return { success: false };
    }
  } catch (err) {
    dispatch({ type: "UPLOAD_AUDIO_FAILED", message: "Something went wrong" });
    return { success: false };
  }
};

export const uploadProctoringImage = async (formData, authToken) => {
  try {
    axios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;

    const response = await axios.post(
      process.env.REACT_APP_API_KEY2 + "test/add-test-images?testImageType=3",
      formData
    );

    return response.data;
  } catch (error) {
    console.error("❌ uploadProctoringImage failed", error);
    throw error;
  }
};